<template>
  <div class="message-status">
    <div class="text-success" v-if="status === INSTANTWIN_MESSAGE_STATUS.SCHEDULE">スケジュール</div>
    <div class="text-primary" v-if="status === INSTANTWIN_MESSAGE_STATUS.ACTIVE">アクティブ</div>
    <div class="text-disabled" v-if="status === INSTANTWIN_MESSAGE_STATUS.FINISHED">終了</div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import { INSTANTWIN_MESSAGE_STATUS } from '@/client/constant'

export default defineComponent({
  props: ['status'],
  data() {
    return {
      INSTANTWIN_MESSAGE_STATUS
    }
  }
})
</script>
